import { type Task } from '@/models/registry';
import { taskStore } from '@/models/stores';
import { toJS } from 'mobx';

const useTasks = (): { tasks: Task[]; isLoading: boolean } => {
  const tasks = toJS(taskStore.all);

  return { tasks, isLoading: false };
};

export default useTasks;
